import styled from 'styled-components'

export const SelectProductsText = styled.p`
  margin: 0;
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
  letter-spacing: ${props => props.theme.texts.bodyMRegular.letterSpacing};
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp24};
  color: ${props => props.theme.colors.black};
`
